// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Pvps","header":"ReportDetails_header__2CzM7","title":"ReportDetails_title__9KlgS","left":"ReportDetails_left__37laU"};